import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

import type { Ga4PageMetrics, Ga4Property, Ga4ReportStatus } from './types'

export const ga4Selectors = {
  getStatus: (state: AppState): Ga4ReportStatus => state.ga4.status,
  // Подключение — это и есть последний разрешённый статус ok: во время
  // обновления он не меняется, отдельной памяти для него не нужно.
  getConnected: (state: AppState): boolean => state.ga4.status === 'ok',
  getUpdatedAt: (state: AppState): number | null => state.ga4.updatedAt,
  getHostname: (state: AppState): string => state.ga4.hostname,
  getPropertyId: (state: AppState): string | null => state.ga4.propertyId,
  getPropertyName: (state: AppState): string | null => state.ga4.propertyName,
  getPageMetrics:
    (id: ID) =>
    (state: AppState): Ga4PageMetrics | null =>
      state.ga4.pages[id] || null,
  getProperties: (state: AppState): Ga4Property[] | null =>
    state.ga4.properties,
  getPropertiesLoading: (state: AppState): boolean =>
    state.ga4.propertiesLoading,
  getConnecting: (state: AppState): boolean => state.ga4.connecting,
  getSavingProperty: (state: AppState): boolean => state.ga4.savingProperty,
  getResyncing: (state: AppState): boolean => state.ga4.resyncing,
}
